import {
  MULTICURRENCY_RECHARGE,
  MULTICURRENCY_PAYCONFIRM
} from "../apis/payment";

export default {
  data() {
    return {
      query_timer: 0,
      query_pay_num: 0
    };
  },
  methods: {
    // 多货币支付方式
    onMulticurrencyPayment(rechargeType, callback) {
      this.MulticurrencyRecharge(rechargeType, callback);
    },
    /** 多货币充值方式
     * https://app.apifox.com/link/project/1121455/apis/api-265418758
     */
    async MulticurrencyRecharge(rechargeType = "balance", callback) {
      try {
        if (this.payType === "PO" || this.payType === "FK") {
          rechargeType = "pay";
        }
        if (this.payType === "VIP") rechargeType = "vip";
        const query = {
          paymentId: this.pId,
          amount: this.price || "",
          rechargeType: rechargeType,
          userOpenId: this.user.p_openID,
          rentNow: rechargeType === "balance",
          qrCode: this.qrcode || this.$route.query.cabinetID || ""
        };
        if (!query.rentNow && this.orderId) {
          query.qrCode = "";
          query.outTradeNo = this.orderId;
        }
        const headers = {
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        };
        this.$loading(true);
        const Payment = this.selectPayment || { paymentMethodType: "" };
        // if (Payment.paymentMethodType.includes('Wechat')) {
        //   query.version = "1.0.0"
        //   query.osType = this.system === "ios" ? "iphone" : this.system
        // }
        const { data = {} } = await this.$Request(
          "POST",
          MULTICURRENCY_RECHARGE,
          query,
          headers
        );
        console.log("PAY RECHARGE:", query, data);
        const payType = Payment.paymentMethodType || data.paymentType || "";
        if (data.outTradeNo && payType.includes("Alipay")) {
          this.queryPaymentConfirm(data, callback);
          window.location.href = data.paymentInfo.payUrl;
          return false;
        } else if (data.approvalUrl && payType.includes("RmPay")) {
          window.location.href = data.approvalUrl;
          return false;
        } else if (data.outTradeNo && payType.includes("Wechat")) {
          this.wechatPayRequest(data.paymentInfo, res => {
            this.$loading(false);
            if (res) callback && callback(data);
          });
          return false;
        }
        throw new Error(data.message);
      } catch (error) {
        this.$loading(false);
        this.$toast(error);
        throw new Error(error);
      }
    },
    // 多货币确认支付方式
    async MulticurrencyConfirm(outTradeNo, tradeNo) {
      const query = { outTradeNo: outTradeNo || "", tradeNo: tradeNo || "" };
      const { data = {} } = await this.$Request(
        "GET",
        MULTICURRENCY_PAYCONFIRM,
        query
      );
      return data;
    },
    // 查询支付确认
    async queryPaymentConfirm(Payment, callback) {
      if (this.query_pay_num > 12) {
        clearTimeout(this.query_timer);
        this.query_pay_num = 0;
        return false;
      }
      const callbackCell = result => {
        if (result && result.orderStatus === 1) {
          this.$loading(false);
          callback && callback(Payment);
        } else {
          this.query_pay_num++;
          this.query_timer = setTimeout(() => {
            this.queryPaymentConfirm(Payment, callback);
          }, 2200);
        }
      };
      if (Payment.outTradeNo) {
        await this.MulticurrencyConfirm(Payment.outTradeNo, Payment.tradeNo)
          .then(result => {
            callbackCell(result);
          })
          .catch(res => {
            callbackCell(res);
          });
      }
    },
    wechatPayRequest(paymentInfo, callback) {
      // const sdkParams = {
      //   appId: data.appId,
      //   timeStamp: data.timeStamp,
      //   nonceStr: data.nonceStr,
      //   package: data.package,
      //   signType: data.signType,
      //   paySign: data.paySign
      // }
      const sdkParams = paymentInfo.sdkParams;
      console.log("wechat pre pay", sdkParams, paymentInfo);
      if (window.WeixinJSBridge) {
        window.WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          sdkParams,
          function(res) {
            console.log("WeixinJSBridge pay===", res);
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              callback && callback(res);
            }
          }
        );
      } else {
        callback && callback();
        console.warn("非微信环境 WeixinJSBridge 未定义");
      }
    }
  }
};
